import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectSceneryState = (state: AppState) =>
  state.scenery;


export const selectSceneries = createSelector(
    selectSceneryState,
  (state) => state.sceneries
);
export const selectSceneryAdded = createSelector(
    selectSceneryState,
  (state) => state.sceneryAdded
);
export const selectSceneryAdding = createSelector(
    selectSceneryState,
  (state) => state.sceneryAdding
);
export const selectSceneryEdited = createSelector(
    selectSceneryState,
  (state) => state.sceneryEdited
);
export const selectSceneryEditing = createSelector(
    selectSceneryState,
  (state) => state.sceneryEditing
);
export const selectSteps = createSelector(
    selectSceneryState,
  (state) => state.steps
);
export const selectSceneryActions = createSelector(
    selectSceneryState,
  (state) => state.actions
);
export const selectStepAdded = createSelector(
    selectSceneryState,
  (state) => state.stepAdded
);
export const selectStepEdited = createSelector(
    selectSceneryState,
  (state) => state.stepEdited
);
